export function isProductCanceled(productTaxonomies: string[] | undefined): boolean {
  return productTaxonomies?.includes('/canceled') ?? false;
}
